import React from "react";
import { BasicTabs, CardWithActions, LineDivider } from "@/components";
import CardContent from "@/pages/attendanceManagement/components/CardContent";
import AttendanceReport from "./AttendanceReport";
import RegularizationReport from "./RegularizationReport";

function ReportProcess() {
  return (
    <CardContent title={"Reports"}>
      <BasicTabs
        tabs={[
          {
            label: "Regularization Report",
            component: <RegularizationReport />,
          },
          {
            label: "Attendance Report",
            component: <AttendanceReport />,
          },
        ]}
      /></CardContent>
  );
}

export default ReportProcess;
